(function(){
  /*
  * Reference Shopify API
  * https://help.shopify.com/en/themes/development/getting-started/using-ajax-api
  */
  var $cartForm = $('#cart-form');
  var $cartMinus = $cartForm.find('.qty-button.qty-minus');
  var $cartPlus = $cartForm.find('.qty-button.qty-plus');
  var $remove = $cartForm.find('.remove');
  var $cartPrice = $cartForm.find('.total-price');
  var $emptyCart = $('.on-empty-cart');

  function onError(e) {
    console.error(e);
  }

  function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  }

  function calculateTotalQty() {
    var totalCounter = 0;

    $.each($('.cart-row'), function(){
      var $this = $(this);
      var qty = $this.find('.quantity-selector').val();
      totalCounter = totalCounter + parseInt(qty);
    });

    return totalCounter;
  }

  function onTotalChanged(total) {
    var qty = calculateTotalQty();
    $('#meta .count').html('<span class="cart-text">(</span>'+qty+'<span class="cart-text">)</span>');

    if (total === 0) {
      // do something
      $cartForm.hide();
      $emptyCart.show();
    }
  }

  function updateTotalPrice() {
    var request = $.getJSON('/cart.js');
    function onChange(data) {
      var totalPrice = Shopify.formatMoney(data.total_price);
      $cartPrice.html(endsWith(totalPrice, '.00') ? totalPrice.replace('.00', '') : totalPrice);
      onTotalChanged(parseInt(totalPrice.replace('$', '')));
    }
    request.then(onChange, onError);
  }

  function onRemoveItem($el, itemId) {

    $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: {
        quantity: 0,
        id: itemId
      },
      // contentType: 'application/json;charset=UTF-8',
      dataType: 'json',
      success: function (data) {
        var parent = $el.closest('.cart-row');
        if (parent.data('id') === itemId) {
          parent.remove();
          updateTotalPrice();
        }
      },
      error: onError
    });
  }


  // Add Listeners
  $remove.on('click', function(e) {
    e.preventDefault();
    onRemoveItem($(this), $(this).data('id'));
  });

})();
